<template>
    <header id="live-header">
        <div class="container-fluid">
            <div class="header-logo">
                <a href="/">
                    <img src="/img/logo_animate_dark.gif" alt="Store Glide" class="logo">
                    <img src="/img/logo_strgld_dark.gif" alt="Store Glide" class="mobile-logo"/>
                </a>
            </div>
            <div class="wrapper-controls">
                <base-drop-down-menu :label="activePageLabel" white>
                    <base-drop-down-item link="/live" label="Live view" active />
                    <base-drop-down-item link="/top" label="Top charts" />
                    <base-drop-down-item link="/collections" label="Collections" />
                </base-drop-down-menu>
            </div>
            <div class="wrapper-panel">
                <div class="user-panel" v-if="authUser && !filterActive">
<!--                    <custom-drop-down-->
<!--                        icon="/img/notice_icon.svg" id="notifications"-->
<!--                        @click="openNotifications"-->
<!--                        v-click-outside="outsideNotificationClick"-->
<!--                        :is-open="notificationsActive">-->
<!--                        <title-drop-down-item label="Fast test" />-->
<!--                        <notification-drop-down-item-->
<!--                            icon="/img/app/1.png"-->
<!--                            app-name="Stealth Master"-->
<!--                            creator="SayGames LLC" />-->
<!--                        <notification-drop-down-item-->
<!--                            icon="/img/app/2.png"-->
<!--                            app-name="Steam Mobile"-->
<!--                            creator="Valve" />-->
<!--                        <notification-drop-down-item-->
<!--                            icon="/img/app/3.png"-->
<!--                            app-name="Skin Stealer Pro for Minecr..."-->
<!--                            creator="Seejaykay LLC" />-->
<!--                        <notification-drop-down-item-->
<!--                            icon="/img/app/4.png"-->
<!--                            app-name="Steak ‘n Shake Rewards Cl..."-->
<!--                            creator="Steak ‘n Shake" />-->

<!--                        <title-drop-down-item label="Stealth test" id="stealth"/>-->
<!--                        <notification-drop-down-item-->
<!--                            icon="/img/app/2.png"-->
<!--                            app-name="Steam Mobile"-->
<!--                            creator="Valve" />-->
<!--                    </custom-drop-down>-->
                    <custom-drop-down
                        :image="avatar"
                        id="profile"
                        @click="openProfile"
                        :is-open="profileActive"
                        v-click-outside="outsideProfileClick"
                    >
                        <profile-drop-down-item :auth-status="authUser" :email="email" />
                    </custom-drop-down>
                </div>
                <form id="login-form" v-else>
                    <button type="button" data-toggle="modal" data-target="#loginModal" class="btn login-btn">Log in</button>
                </form>
                <div class="mobile-control" v-if="!filterActive && !searchActive">
                    <custom-drop-down
                        @click="openOptions"
                        :is-open="mobileOptionsActive"
                        icon="/img/menu-dots.svg"
                        v-click-outside="outsideMenuOptionsClick"
                    >
                        <action-drop-down-item icon="/img/search-black.svg" label="Search" @click="openSearch"/>
                        <action-drop-down-item icon="/img/mobile_filter_black.svg" label="Filter" @click="openFilter"/>
                        <profile-drop-down-item :auth-status="authUser" :email="email" />
                    </custom-drop-down>
                </div>
                <div v-if="filterActive">
                    <button class="close-filter"><img src="/img/close.svg" alt="Close filter" @click.prevent="closeFilter"></button>
                </div>
                <div v-if="searchActive">
                    <button class="close-filter"><img src="/img/close.svg" alt="Close search" @click.prevent="closeSearch"></button>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import BaseDropDownMenu from '../ui/BaseDropDownMenu';
import BaseDropDownItem from '../ui/parts/BaseDropDownItem';
import CustomDropDown from '../ui/CustomDropDown';
import ProfileDropDownItem from '../ui/parts/ProfileDropDownItem';
import TitleDropDownItem from '../ui/parts/TitleDropDownItem';
import ActionDropDownItem from '../ui/parts/ActionDropDownItem';
import NotificationDropDownItem from '../ui/parts/NotificationDropDownItem';

export default {
    inheritAttrs: false,
    name: 'live-header',
    components: {
        BaseDropDownMenu,
        BaseDropDownItem,
        CustomDropDown,
        ProfileDropDownItem,
        ActionDropDownItem,
        TitleDropDownItem,
        NotificationDropDownItem
    },
    props: {
        activePageLabel: {
            type: String,
            default: 'Live View',
            description: 'Item label',
        },
    },
    created() {
        window.addEventListener("scroll", this.scrollHandler);
    },
    computed: mapGetters(['filterActive', 'mobileOptionsActive', 'profileActive', 'notificationsActive', 'searchActive']),
    data() {
        return {
            authUser: window.authUser,
            avatar: window.avatar,
            email: window.email,
            scrollLastPosition: 0
        };
    },
    methods: {
        ...mapMutations([
            'toggleSearchActive',
            'setFilterActive',
            'setFilterNotActive',
            'toggleMobileOptionsActive',
            'closeMobileOptions',
            'toggleProfileActive',
            'closeProfile',
            'toggleNotificationsActive',
            'closeNotifications',
            'restoreActiveItems',
            'setSearchActive',
            'setSearchNotActive',
        ]),
        scrollHandler(e) {
            let positionY = window.scrollY;
            let width = window.innerWidth;
            let header = document.getElementById('live-header');
            let appSelector = document.getElementById('app');

            if (width > 991) {
                if (positionY < this.scrollLastPosition) {
                    setTimeout(function () {
                        header.classList.add('active');
                        appSelector.style.paddingTop = '100px';
                    }, 500)
                } else {
                    if (positionY > 60) {
                        header.classList.add('transform');
                    }
                    header.classList.remove('active');
                    appSelector.style.paddingTop = '0';
                }
                this.scrollLastPosition = positionY;
            }
        },
        openSearch() {
            this.setSearchActive();
        },
        closeSearch() {
            this.setSearchNotActive();
        },
        openFilter() {
            this.setFilterActive();
            document.documentElement.classList.add('blocked');
            document.body.classList.add('blocked');
        },
        closeFilter() {
            this.setFilterNotActive();
            document.documentElement.classList.remove('blocked');
            document.body.classList.remove('blocked');
        },
        openOptions() {
            this.toggleMobileOptionsActive();
        },
        openProfile() {
            this.toggleProfileActive();
        },
        openNotifications() {
            this.toggleNotificationsActive();
        },
        outsideNotificationClick() {
            this.closeNotifications();
        },
        outsideProfileClick() {
            this.closeProfile();
        },
        outsideMenuOptionsClick() {
            this.closeMobileOptions();
        }
    }
};
</script>

<style lang="scss">
    #live-header {
        position: relative;
        background: linear-gradient(99.26deg, rgba(36, 0, 255, 0) 3.48%, rgba(170, 0, 230, 0.28) 49.55%, rgba(255, 0, 199, 0.65) 98.6%), #200033;
        height: 60px;
        margin-bottom: 40px;
        padding: 0 40px;
        text-align: center;
        width: 100%;
        z-index: 500;
        transition: transform .35s ease 0s;
        display: flex;
        top: 0;
        .container-fluid {
            align-items: center;
            .wrapper-controls {
                display: inline-block;
            }
        }
        .wrapper-panel {
            .user-panel {
                display: flex;
                align-items: center;
                .drop-down {
                    button {
                        .image {
                            width: 34px;
                            border-radius: 40px;
                            border: 2px solid #9240F5;
                        }
                    }
                }
                #notifications {
                    .content {
                        padding: 20px 18px;
                        #stealth {
                            margin-top: 20px;
                        }
                    }
                }
            }
            #login-form {
                .btn {
                    margin-top: 0;
                }
            }
        }
        .wrapper-controls {
            &.xs {
                display: none;
            }
            &:focus-visible {
                outline: none;
            }
        }
        .mobile-control {
            #profile-item {
                padding-left: 0px;
            }
        }
        .close-filter {
            background: transparent;
            border: none;
            outline: none;
        }
    }

    @media only screen and (max-width: 991px) {
        #live-header {
            #login-form {
                display: none;
            }
            padding: 0;
            position: fixed;
            .wrapper-panel {
                display: flex;
                flex-direction: row;
                align-items: center;
                .user-panel {
                    #profile {
                        display: none;
                    }
                    margin-right: 10px;
                }
            }
        }
    }
    @media only screen and (max-width: 560px) {
        #live-header {
            .wrapper-panel {
                .user-panel {
                    #notifications {
                        .content {
                            right: -80px;
                        }
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 500px) {
        #live-header {
            .mobile-logo {
                width: 75px;
            }
            .wrapper-controls {
                .drop-down {
                    button {
                        font-size: 16px;
                    }
                    .menu {
                        .item {
                            font-size: 14px;
                        }
                    }
                }
            }
            .wrapper-panel {
                .user-panel {
                    .drop-down {
                        button {
                            .image {
                                width: 29px;
                            }
                            .icon {
                                width: 35px;
                            }
                        }
                    }
                    #notifications {
                        .content {
                            right: -50px;
                            .item {
                                min-width: 290px;
                                .wrapper-content {
                                    .info {
                                        .name {
                                            width: 145px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>

